import { useRef, useEffect } from "react"
import { geoMercator, geoPath } from "d3"
import Datamap from "datamaps/dist/datamaps.world.hires.js"
import networkLocations from "@content/network_locations.json"

const CompanyMap = () => {
  const mapContainer = useRef(null)
  const mapObject = useRef(null)

  const APACPOPs = networkLocations.filter((loc) => loc.latitude < 38 && loc.longitude > 67)

  useEffect(() => {
    mapObject.current = new Datamap({
      element: mapContainer.current,
      scope: "world",
      responsive: true,
      width: 1920,
      height: 1080,
      geographyConfig: {
        popupOnHover: false,
        highlightOnHover: false,
        borderColor: "#FFFFFF",
      },
      fills: {
        single: "var(--blue)",
        multiple: "var(--blue-dark)",
        planned: "var(--magenta)",
        upgrade: "var(--green)",
        defaultFill: "var(--grey-40)",
      },
      bubblesConfig: {
        borderWidth: 1,
        radius: 10,
        highlightFillColor: "#2D3741",
        highlightBorderColor: "#FFFFFF",
      },
      setProjection: function () {
        var projection = geoMercator().center([55, 30]).scale(500)
        var path = geoPath().projection(projection)
        return { path: path, projection: projection }
      },
    })

    mapObject.current.bubbles(APACPOPs, {
      popupTemplate: function (geo, data) {
        return ['<div class="network-map__hover-info">' + data.name + "</div>"].join("")
      },
    })

    const resizeFunction = () => {
      mapObject.current.resize()
    }

    window.addEventListener("resize", resizeFunction)
    // Need to resize after page load to adjust map to window size
    window.addEventListener("load", resizeFunction)

    setTimeout(resizeFunction, 100)

    return () => {
      window.removeEventListener("resize", resizeFunction)
      window.removeEventListener("load", resizeFunction)
    }
  }, [])

  return (
    <section className="page-section__maps section section--page-section section--map">
      <div className="section__row">
        <div className="network-map-container pops">
          <div ref={mapContainer} id="map"></div>
        </div>
      </div>
    </section>
  )
}

export default CompanyMap
